'use client';

import { Button } from '@nextui-org/react';
import Image from 'next/image';

import PulsatingButton from '@/components/ui/PulsatingButton';
import { sendYMEvent, YM_TARGETS_ENUM } from '@/shared/const/ym';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';
import { cn } from '@/shared/utils/utils';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { SocialLinks } from '@/components/layout/footer/footer';
import { SITE_STATS } from '@/shared/constants/site-stats';

export const Hero = () => {
  const router = useRouter();
  useEffect(() => {
    router.prefetch(ROUTES.cart);
    router.prefetch(ROUTES.masterclasses);
  }, [router]);

  return (
    <div className="hero flex flex-col w-full gap-8 pt-[40px]">
      {/* был <main>, но единственный main теперь в (ru)/layout — вложенные main невалидны */}
      <div
        className={cn(
          'rounded-3xl flex md:flex-row flex-col  md:gap-10 gap-4 pt-20  lg:min-h-[800px] md:min-h-[500px]  rounded-b-3xl  -mt-[136px] justify-between items-center px-4 md:px-8',
        )}
      >
        <section className="py-4 md:py-8 justify-center flex flex-col items-center gap-6">
          <Link href={ROUTES.masterclasses}>
            <button
              className="z-0 group relative inline-flex items-center justify-center box-border appearance-none select-none whitespace-nowrap font-normal subpixel-antialiased overflow-hidden tap-highlight-transparent data-[pressed=true]:scale-[0.97] outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 min-w-20 text-small gap-2 rounded-full [&>svg]:max-w-[theme(spacing.8)] transition-transform-colors-opacity motion-reduce:transition-none data-[hover=true]:opacity-hover h-9 bg-background px-[18px] text-default-500 shadow-[0_2px_15px_0_rgba(0,0,0,0.05)]"
              type="button"
            >
              К новинкам
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                role="img"
                className="pointer-events-none flex-none outline-none [&>path]:stroke-[1.5] iconify iconify--solar"
                focusable="false"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#fdc64d"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M4 12h16m0 0l-6-6m6 6l-6 6"
                />
              </svg>
            </button>
          </Link>{' '}
          <h1 className="text-center text-[clamp(2.125rem,1.142rem+3.659vw,4rem)] font-bold leading-none text-foreground">
            Мастер-классы по вязанию игрушек амигуруми крючком
          </h1>
          <p className="text-center text-base text-default-600 sm:w-[466px] md:text-lg md:leading-6">
            Привет! Меня зовут Марина Камбур. Здесь ты найдёшь самые понятные
            пошаговые мастер-классы со схемами и описанием, по которым свяжешь
            любую игрушку крючком на одном дыхании.
          </p>
          <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
            <Link href={ROUTES.masterclasses}>
              <PulsatingButton
                duration="2s"
                onClick={() => sendYMEvent(YM_TARGETS_ENUM.GO_TO_MASTERCLASSES)}
              >
                Перейти к мастер-классам
              </PulsatingButton>
            </Link>
          </div>
        </section>
        <div className="flex flex-col md:w-3/4 max-w-[600px] w-full justify-center space-y-4">
          <Image
            alt="Вязаные игрушки амигуруми ручной работы — мастер-классы Марины Камбур"
            className="object-cover rounded-lg"
            height={600}
            src="/hero.webp"
            width={600}
            priority
            sizes="(max-width: 768px) 100vw, 600px"
          />
        </div>
      </div>
      <Features />
      <div className="w-full flex flex-col justify-center items-center px-4 md:px-8"></div>
    </div>

    // <div className="flex md:flex-row flex-col  md:gap-10 gap-4">
    //   <div className="flex flex-col  justify-center space-y-4">
    //     <div className="space-y-2">
    //       <h1 className="text-4xl font-bold tracking-tighter lg:text-5xl  xl:text-6xl">
    //         Привет! Меня зовут Марина Камбур
    //       </h1>
    //       <p className="max-w-[600px]  text-lg text-gray-500">
    //         Тут ты найдешь самые понятные МК, по которым свяжешь любую игрушку
    //         на одном дыхании
    //       </p>
    //     </div>
    //
    //   </div>
    //   <div className="flex flex-col md:w-3/4 w-full justify-center space-y-4">
    //     <Image
    //       as={NextImage}
    //       alt="image"
    //       className="object-cover rounded-lg"
    //       height="1000"
    //       src="/hero.jpg"
    //       width="1000"
    //       priority
    //     />
    //   </div>
    // </div>
  );
};

const features = [
  {
    icon: (
      <svg
        aria-hidden="true"
        fill="none"
        focusable="false"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        width="24"
        className="text-pink-500"
      >
        <path
          d="M3.5 20.5c.83.83 2.17.83 3 0l13-13c.83-.83.83-2.17 0-3-.83-.83-2.17-.83-3 0l-13 13c-.83.83-.83 2.17 0 3ZM18.01 8.99l-3-3"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M8.5 2.44 10 2l-.44 1.5L10 5l-1.5-.44L7 5l.44-1.5L7 2l1.5.44ZM4.5 8.44 6 8l-.44 1.5L6 11l-1.5-.44L3 11l.44-1.5L3 8l1.5.44ZM19.5 13.44 21 13l-.44 1.5L21 16l-1.5-.44L18 16l.44-1.5L18 13l1.5.44Z"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: SITE_STATS.masterclassesCount,
    description: (
      <div className="flex flex-col gap-2">
        <p>Которые стали настоящими бестселлерами</p>
        <Link href={ROUTES.masterclasses}>
          <Button size="sm" variant="bordered">
            Подробнее
          </Button>
        </Link>
      </div>
    ),
  },
  {
    icon: (
      <svg
        aria-hidden="true"
        fill="none"
        focusable="false"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        width="24"
        className="text-pink-500"
      >
        <path
          d="M6.09 13.28h3.09v7.2c0 1.68.91 2.02 2.02.76l7.57-8.6c.93-1.05.54-1.92-.87-1.92h-3.09v-7.2c0-1.68-.91-2.02-2.02-.76l-7.57 8.6c-.92 1.06-.53 1.92.87 1.92ZM18.01 8.99l-3-3"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </svg>
    ),
    title: SITE_STATS.studentsCount,
    description: 'Уже связали игрушки по моим мастер-классам',
  },
  {
    icon: (
      <svg
        aria-hidden="true"
        focusable="false"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        width="24"
      >
        <path
          d="M20.742,13.045c-0.677,0.18-1.376,0.271-2.077,0.271c-2.135,0-4.14-0.83-5.646-2.336c-2.008-2.008-2.799-4.967-2.064-7.723 c0.092-0.345-0.007-0.713-0.259-0.965C10.444,2.04,10.077,1.938,9.73,2.034C8.028,2.489,6.476,3.382,5.241,4.616 c-3.898,3.898-3.898,10.243,0,14.143c1.889,1.889,4.401,2.93,7.072,2.93c2.671,0,5.182-1.04,7.07-2.929 c1.236-1.237,2.13-2.791,2.583-4.491c0.092-0.345-0.008-0.713-0.26-0.965C21.454,13.051,21.085,12.951,20.742,13.045z M17.97,17.346c-1.511,1.511-3.52,2.343-5.656,2.343c-2.137,0-4.146-0.833-5.658-2.344c-3.118-3.119-3.118-8.195,0-11.314 c0.602-0.602,1.298-1.102,2.06-1.483c-0.222,2.885,0.814,5.772,2.89,7.848c2.068,2.069,4.927,3.12,7.848,2.891 C19.072,16.046,18.571,16.743,17.97,17.346z"
          fill="#fdc64d"
        />
      </svg>
    ),
    title: SITE_STATS.experienceYears,
    description: 'Пишу мастер-классы уже более 8 лет',
  },
  {
    icon: (
      <svg
        aria-hidden="true"
        fill="none"
        focusable="false"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        width="24"
        className="text-pink-500"
      >
        <path
          d="M18 18.86h-.76c-.8 0-1.56.31-2.12.87l-1.71 1.69c-.78.77-2.05.77-2.83 0l-1.71-1.69c-.56-.56-1.33-.87-2.12-.87H6c-1.66 0-3-1.33-3-2.97V4.98c0-1.64 1.34-2.97 3-2.97h12c1.66 0 3 1.33 3 2.97v10.91c0 1.63-1.34 2.97-3 2.97Z"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        ></path>
        <path
          d="M12 10a2.33 2.33 0 1 0 0-4.66A2.33 2.33 0 0 0 12 10ZM16 15.66c0-1.8-1.79-3.26-4-3.26s-4 1.46-4 3.26"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></path>
      </svg>
    ),
    title: SITE_STATS.socialFollowers,
    description: (
      <div className="flex flex-col gap-2">
        <p>Присоединяйся к нам и становись частью активного сообщества</p>
        <SocialLinks />
      </div>
    ),
  },
  {
    icon: (
      <svg
        aria-hidden="true"
        fill="none"
        focusable="false"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        width="24"
        className="text-pink-500"
      >
        <path
          d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.563.563 0 0 0-.586 0l-4.725 2.885a.562.562 0 0 1-.84-.61l1.285-5.385a.563.563 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345l2.125-5.111Z"
          stroke="#fdc64d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    ),
    title: SITE_STATS.reviewsCount,
    description: (
      <div className="flex flex-col gap-2">
        <p>От рукодельниц, которые уже связали игрушки по моим схемам</p>
      </div>
    ),
  },
];

const Features = () => {
  return (
    <div className="grid md:px-8 px-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-8">
      {features.map((feature, index) => (
        <div
          key={index}
          className="flex flex-col relative overflow-hidden h-auto text-foreground box-border outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 shadow-medium rounded-large transition-transform-background motion-reduce:transition-none border-transparent bg-white/5 dark:bg-default-400/10 backdrop-blur-lg backdrop-saturate-[1.8]"
        >
          <div className="flex p-3 z-10 w-full justify-start items-center shrink-0 overflow-inherit color-inherit subpixel-antialiased rounded-t-large gap-2 pb-0">
            <div className="flex justify-center p-2 rounded-full items-center bg-yellow-50">
              {feature.icon}
            </div>
            <p className="text-base font-semibold">{feature.title}</p>
          </div>
          <div className="relative flex w-full p-3 flex-auto flex-col place-content-inherit align-items-inherit h-auto break-words text-left overflow-y-auto subpixel-antialiased">
            <div className="font-normal text-base text-default-500">
              {feature.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
